/* =============================================================================
 * Product Short Description (w95kdldr)
 *
 * Plain content block — no interactions to track. This file exists for two
 * reasons:
 *
 *   1. Snippet-library convention: every snippet ships a JS file alongside
 *      its main `.liquid` so the wrapper's `<script src=…>` tag always
 *      resolves.
 *   2. Per-instance bind handshake: calling `__spectrumAi.snippet.bind(node,
 *      callback)` lets the bootstrap SDK match the snippet instance to its
 *      analytics envelope (snippet_id, instance_id, experience_id, …) for the
 *      auto-fired `snippet:impression` baseline event.
 *
 * No custom events are emitted by this snippet. Only the baseline impression
 * fires.
 *
 * No-bind fallback: if window.__spectrumAi is absent (theme without the
 * Spectrum app embed installed), the SSR'd content remains visible and
 * functional; analytics are silently skipped.
 *
 * Trust boundary:
 *   The server template owns content safety — `entry.content.text` is escaped,
 *   and `entry.content.html` (rich brands) is pre-sanitised and emitted raw.
 *   This file never reads or mutates the rendered content; it only binds the
 *   container for the impression envelope.
 * ============================================================================= */

;(() => {
  if (window.__sai_w95kdldr_initialized__) return
  window.__sai_w95kdldr_initialized__ = true

  const SNIPPET_ID = 'w95kdldr'

  function bindAllContainers() {
    const api = window.__spectrumAi?.snippet
    const containers = document.querySelectorAll(
      `[data-spectrum-instance-id][data-spectrum-snippet-id="${SNIPPET_ID}"]`,
    )

    if (!api?.bind) {
      // No-bind fallback: SSR'd content remains visible. The auto-fired
      // `snippet:impression` baseline still ships via the bootstrap SDK's
      // viewport observer, but without this snippet's envelope it would miss
      // the per-instance metadata.
      return
    }

    for (const node of containers) {
      api.bind(node, () => {
        // No applyVariant rebuild for this snippet — the SSR'd text is stable
        // for the page lifetime. The callback exists only so bind() can
        // resolve the variant and hand the envelope to the impression
        // baseline. No custom events to wire.
      })
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAllContainers, { once: true })
  } else {
    bindAllContainers()
  }
})()
